import { getUserId } from 'redux/selectors/user';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { dayPropertiesAdapter, isDayLockedForUser } from './dayProperties';
import type { DayProperties } from './dayProperties.schema';

const selectors = dayPropertiesAdapter.getSelectors<IState>(state => state.dayProperties);

export const getDayProperties = createSelector(selectors.selectAll, dayProperties => {
  return dayProperties.reduce(
    (acc, property) => {
      const date = property.date;
      acc[date] ??= [];
      acc[date].push(property);
      return acc;
    },
    {} as Record<string, Array<DayProperties>>
  );
});

export const getIsDayLockedByDate = createSelector(
  getUserId,
  getDayProperties,
  (_, date: string) => date,
  (userId, dayProperties, date) => isDayLockedForUser(userId, dayProperties[date])
);
